import { render, staticRenderFns } from "./groupInfo.vue?vue&type=template&id=788df3f5&scoped=true"
import script from "./groupInfo.vue?vue&type=script&lang=js"
export * from "./groupInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788df3f5",
  null
  
)

export default component.exports